import React, { Component } from 'react';
import Dropdown from 'react-dropdown'
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {MASTER, SLAVE} from 'constants/clock-types.js';
import {SYNCED} from 'constants/connection-status-types.js';
import ethereum from 'decentralized/ethereum.js';

class ClockOptions extends Component {
    componentDidMount() {
        this.props.sequencerEngine.clockSync.startListening();
    }

    async onClickUser(user) {
        if (this.props.connectionStatus === SYNCED) {
            return;
        }
        let userId = await ethereum.users.getUserId(user);
        this.props.sequencerEngine.clockSync.setClockType(SLAVE);
        this.props.sequencerEngine.clockSync.syncToUser(userId);
    }

    onSelectClockType(o) {
        this.props.sequencerEngine.clockSync.setClockType(o.value);
    }

    render() {
        return (
            <div className="clock-type-container">
              <div className="sub-header">Clock Syncing</div>
              <div>Clock Type</div>
              <Dropdown
                className='audio-input-chooser-dropdown'
                controlClassName='audio-input-chooser-dropdown'
                arrowClassName='osc-type-arrow-dropdown'
                options={CLOCK_OPTIONS}
                onChange={(o) => this.onSelectClockType(o)}
                value={getClockOption(this.props.clockType)}
                placeholder="Osc. Type" />
                <div className="available-users">
                  People available to connect:
                  {this.props.availableUsers.map(
                      user =>
                          <div
                                onClick={() => this.onClickUser(user)}
                                className={this.getClassName(user)}>{user}
                                <ConditionedComponent condition={this.props.connectionStatus === SYNCED}>
                                      <div className="user-status">CONNECTED</div>
                                </ConditionedComponent>
                          </div>)}
                </div>
            </div>
        );
    }

    getClassName(userName) {
        return userName === this.props.connectedUserName ?
            "available-user selected" : "available-user";
    }
}

const CLOCK_OPTIONS = [
    {value: 'NONE', label: 'None'},
    {value: MASTER, label: 'Master'},
    {value: SLAVE, label: 'Slave'},
];

function getClockOption(val) {
    return CLOCK_OPTIONS.filter(
        opt => opt.value === val)[0];
}

const mapStateToProps = state => {
    return {
        clockType: state.sequencer.clockType,
        availableUsers: state.sequencer.clockType === MASTER ? [] : state.clock.availableUsers,
        connectedUserName: state.clock.connectedUserName,
        connectionStatus: state.clock.connectionStatus,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(ClockOptions);
